import { useGetDefaultPaymentsAccountDetailsQuery } from '../../__generated__/chirp/com/hubspot/payments/accounts/rpc/PaymentsAccountEligibilityService.hooks';
export const useDefaultPaymentsAccountDetails = options => useGetDefaultPaymentsAccountDetailsQuery(Object.assign({
  useLegacyFieldNameMode: true
}, options));